<template>
  <div class="global-file-viewer">
    <MediaViewer
      v-if="mediaIsOpen"
      :items="mediaItems"
      :index="mediaIndex"
      :hide-open-morphable="hideOpenMorphable"
      :hide-minimize="hideMinimize"
      v-on="$listeners"
    />

    <DocumentViewer
      v-if="documentItem"
      :item="documentItem"
      :revision-context="documentRevisionContext"
      :revision-loading="revisionLoading"
      v-on="$listeners"
    />

    <ForgeFileViewer
      v-if="forgeItem"
      :item="forgeItem"
      :revision-context="forgeRevisionContext"
      :revision-loading="revisionLoading"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import MediaViewer from '@/components/Globals/Helpers/MediaViewer'
import DocumentViewer from '@/components/Globals/Helpers/DocumentViewer'
import ForgeFileViewer from '@/components/Globals/Helpers/ForgeFileViewer'

export default {
  name: 'GlobalFileViewer',

  components: {
    MediaViewer,
    DocumentViewer,
    ForgeFileViewer
  },

  props: {
    mediaItems: {
      type: Array,
      default: () => []
    },
    mediaIndex: {
      type: Number,
      default: null
    },
    documentItem: {
      type: Object,
      default: null
    },
    forgeItem: {
      type: Object,
      default: null
    },
    documentRevisionContext: {
      type: Object,
      default: null
    },
    forgeRevisionContext: {
      type: Object,
      default: null
    },
    revisionLoading: {
      type: Boolean,
      default: false
    },
    hideOpenMorphable: {
      type: Boolean,
      default: false
    },
    hideMinimize: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    mediaIsOpen() {
      return this.mediaIndex !== null && this.mediaIndex !== undefined
    }
  },

  watch: {
    documentItem: {
      immediate: true,
      handler(item) {
        this.removeMinimizedFile(item)
      }
    },
    forgeItem: {
      immediate: true,
      handler(item) {
        this.removeMinimizedFile(item)
      }
    },
    mediaItems: {
      handler() {
        this.removeOpenMediaFile()
      }
    },
    mediaIndex: {
      handler() {
        this.removeOpenMediaFile()
      }
    }
  },

  methods: {
    removeOpenMediaFile() {
      if (!this.mediaIsOpen) return
      const mediaItem = this.mediaItems[this.mediaIndex]
      this.removeMinimizedFile(mediaItem?.item || mediaItem)
    },
    removeMinimizedFile(item) {
      if (!item?.id || !this.$store?.globalStore) return
      this.$store.globalStore.commit('removeFileFromFileManagerHandler', item)
    }
  }
}
</script>
